/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { ICoverageDiscoveryResponseStateManager, ICLine, IPcpSectionViewModels } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import './PCPAlertSection.scss'
import { observer } from 'mobx-react'
import React from 'react'
import './PCPAlertSection.scss'
import { injectProperty } from '../../../../arc/configuration/ServiceLocator'
import { ICoverageDiscoveryResponseApiClient } from '../../../../services/CoverageDiscoveryResponseApiClient/contracts'

export interface IPCPAlertSectionProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}
interface IPCPAlertSectionState {
	IsPageLoading: boolean
}

@observer
export class PCPAlertSection extends React.Component<IPCPAlertSectionProps, IPCPAlertSectionState> {
	@injectProperty('ICoverageDiscoveryResponseApiClient')
	public readonly CoverageDiscoveryResponseApiClient!: ICoverageDiscoveryResponseApiClient

	constructor(props: Readonly<IPCPAlertSectionProps>) {
		super(props)
		this.state = {
			IsPageLoading: true,
		}
	}
	componentDidMount(): void {
		this.setIsPageLoadState(false)
	}
	setIsPageLoadState(val: boolean) {
		this.setState({
			IsPageLoading: val,
		})
	}
	renderPcpSection(pcpSectionViewModels: IPcpSectionViewModels[]): any {
		return <tbody>{this.renderPcpData(pcpSectionViewModels)}</tbody>
	}

	renderPcpData(pcpSectionViewModels: IPcpSectionViewModels[]): any {
		const FULLNAME = 'FullName'
		const ADDRESS = 'Address'
		const MESSAGE = 'Message'
		const POLICYNUMBER = 'PolicyNumber'
		const STARTDATE = 'StartDate'
		const ENDDATE = 'EndDate'
		const PLANDESCRIPTION = 'PlanDescription'
		const SERVICETYPE = 'ServiceType'
		const TELEPHONE = 'Telephone'
		const FAX = 'Fax'
		const NPI = 'Npi'
		const EFFECTIVEDATE = 'EffectiveDate'
		let lines: Array<ICLine> = []
		let lineIndex = 1
		return pcpSectionViewModels.map(eligibilityBenefit => {
			lineIndex = eligibilityBenefit.id
			lines = eligibilityBenefit.cLineList
			let index = 0
			if (lines.length > 0) {
				return lines.map((line, uniqueIndex) => {
					const rowClass = index + 1 === lines.length ? 'bottom-border-td' : ''
					let rowIdentifier = ''
					let first = ''
					let second = ''
					for (let i = 0; i < line.sections.length; i++) {
						if (i === 0) {
							let label = ''
							switch (line.sections[i].value) {
								case FULLNAME:
									label = 'PCP Name'
									break
								case ADDRESS:
									label = 'Address'
									break
								case MESSAGE:
									label = 'Message'
									break
								case POLICYNUMBER:
									label = 'Policy #'
									break
								case STARTDATE:
									label = 'Eligibility Begin'
									break
								case ENDDATE:
									label = 'Eligibility End'
									break
								case PLANDESCRIPTION:
									label = 'Plan Description'
									break
								case SERVICETYPE:
									label = 'Service Type'
									break
								case TELEPHONE:
									label = 'Telephone'
									break
								case FAX:
									label = 'Fax'
									break
								case NPI:
									label = 'NPI'
									break
								case EFFECTIVEDATE:
									label = 'Effective Date'
									break
								default:
									break
							}
							first = label + ':'
							rowIdentifier = 'PCP' + lineIndex + '-' + label
						} else {
							second += line.sections[i].value
						}
					}
					index++
					return (
						<tr key={uniqueIndex} className={rowIdentifier}>
							<td className={rowClass}>{first}</td>
							<td className={rowClass} colSpan={3}>
								<span>{second}</span>
							</td>
						</tr>
					)
				})
			}
			return <></>
		})
	}

	render(): React.ReactNode {
		const pcpAlertsSectionSection = this.props.CoverageDiscoveryResponseStateManager.selectedPCPAlertsSection
		if (pcpAlertsSectionSection && pcpAlertsSectionSection.pcpSectionViewModels && pcpAlertsSectionSection.pcpSectionViewModels.length !== 0) {
			return (
				<div className="cdResponsePage">
					<table className="service-types-table">
						<thead>
							<tr className="PCP-header">
								<td colSpan={4} style={{ paddingLeft: '10px' }}>
									<h4>Primary Care Provider</h4>
								</td>
							</tr>
						</thead>
						{this.renderPcpSection(pcpAlertsSectionSection.pcpSectionViewModels)}
					</table>
				</div>
			)
		} else {
			return <></>
		}
	}
}
